export default __webpack_public_path__ + "static/media/actividad-19.02d44ab0.mp3";